import { analytics_api, api_url, getHealthServiceBaseUrl } from "common/services/EnvironmentService";
import { common_loader, snackbar_state } from "common/stores/CommonStore";
import { APIErrorHandling, healthService } from "common/utils/TextConstants";


let loaderArray: Array<{ callType: string; apiURL: string; status: boolean }>;
common_loader.subscribe((res) => (loaderArray = res));




export const getCall = (url: string, headers?: any, nonOriginCall: boolean = false, timeout?: number, optionalArg: any = {}) => {
    // add call to common loader array
    common_loader.update((arr) => [...arr, {  callType: 'GET', apiURL: url, status: true }]);
    let getCallURl = url.includes('v4/health') ? getHealthServiceBaseUrl() + url : url;
    return new Promise(function (resolve, reject) {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', getCallURl);
      headers = {
        'Content-Type': 'application/json',
        ...headers,
        ...(optionalArg.shopifySessionId ? {shopifySessionId: optionalArg.shopifySessionId} : {}),
        ...(optionalArg.shopifyCookieInfo ? {shopifyCookieInfo: optionalArg.shopifyCookieInfo} : {}),
      };
      for (const [key, value] of Object.entries(headers)) {
        //@ts-ignore
        xhr.setRequestHeader(key, value);
      }
      nonOriginCall && (xhr.timeout = 5000);
      timeout && (xhr.timeout = timeout);
  
      // This will be called after the response is received
      xhr.onload = () => {
        try {
          removeLoaderObject('GET', url);
          if (xhr.status !== 200) {
            if (nonOriginCall) {
              reject(xhr.response);
            } else {
              let errMsg = JSON.parse(xhr.response)?.statusMessage;
              sendError(errMsg || APIErrorHandling.generic);
            }
          } else {
            // show the result
            var res = JSON.parse(xhr.response);
            resolve(res);
          }
        } catch (error) {
          reject(xhr.response);
          sendError(error || APIErrorHandling.generic);
          removeLoaderObject('GET', url);
        }
      };
      xhr.onerror = () => {
        removeLoaderObject('GET', url);
        reject(null);
        sendError(APIErrorHandling.generic);
      };
      xhr.ontimeout = () => {
        removeLoaderObject('GET', url);
        reject(null);
      };
      xhr.send();
    });
  };
  
  //analtyicsApi - events - hits
  export const postCall = (url: string, params: any, headers?: any, loader = true) => {
    const callURl = url.includes('hits') || url === analytics_api() ? url : api_url() + url;
  
    return new Promise(function (resolve, reject) {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', callURl);
      headers = {
        'Content-Type': 'application/json',
        ...headers,
      };
      for (const [key, value] of Object.entries(headers)) {
        //@ts-ignore
        xhr.setRequestHeader(key, value);
      }
      //This will be called after the response is received
      xhr.onload = async () => {
        const res = JSON.parse(xhr.response);
        try {
          const res = JSON.parse(xhr.response);
        } catch (err) {
          reject(xhr.response);
          sendError(err || APIErrorHandling.generic);
        }
      };
      xhr.ontimeout = () => {
        reject('API_TIMEOUT');
      };
      xhr.send(JSON.stringify(params));
    });
  };


  function removeLoaderObject(type: string, url: string) {
    if (!url.includes('events') && !url.includes('truecaller')) {
      let index = loaderArray.findIndex((ele) => ele.callType === type && ele.apiURL === url);
      loaderArray.splice(index, 1);
      common_loader.set(loaderArray);
    }
  }

  export function sendError(message) {
    message &&
      message !== healthService.apiError &&
      snackbar_state.set({
        timeout: 4000,
        open: true,
        message: message,
        type: 'error',
      });
  }